import { Alert, AlertDescription } from "@/components/ui/alert";
import { useAuth } from "@/features/auth";
import {
  useContainerMemberQuery,
  useProjectBySlugsQuery,
} from "@/features/containers/api/containers-hooks";
import { IntegrationsPage } from "@/features/integrations";
import { validateIntegrationsSearch } from "@/features/integrations/oauth-return-edit";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/integrations",
)({
  // CR-237/CR-274/CR-295: ?edit=github|linear|jira reopens that card in edit mode after OAuth.
  // CR-288: ?connect=<service> (the /connect/$service deep link) opens the
  // Add-integration dialog on that service's Authorize step.
  validateSearch: validateIntegrationsSearch,
  component: RouteComponent,
});

function RouteComponent() {
  const { slug: workspaceSlug, projectSlug } = useParams({ strict: false });
  const { user } = useAuth();
  const { data: project } = useProjectBySlugsQuery(workspaceSlug, projectSlug);
  const { data: myMembership } = useContainerMemberQuery(user.id, project?.id ?? "");

  // Braced on purpose: wuchale hoists its runtime-hook init above an early
  // return only when the guard's consequent is a block — a braceless guard
  // would leave the injected useState below this return and crash with React
  // error #310 once the queries resolve (see the wuchale gotchas in CLAUDE.md).
  if (!project || myMembership === undefined) {
    return null;
  }

  const isOwner = myMembership.role === "owner";
  const isAdmin = myMembership.role === "admin";

  if (!isOwner && !isAdmin) {
    return (
      <div className="container mx-auto max-w-xl p-10">
        <Alert variant="destructive">
          <AlertDescription>
            You do not have the required permissions to access this page. Only owners and admins can
            manage integrations.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <IntegrationsPage
      containerId={project.id}
      workspaceSlug={workspaceSlug ?? ""}
      projectSlug={projectSlug ?? ""}
    />
  );
}
